<template>
  <div>
    <div class="loader-box-container">
      <div class="loader-box"></div>
      <div class="loader-box-walkway"></div>
    </div>
    <div class="loader-overlay"></div>
  </div>
</template>

<script>
  export default {
    name: 'loader-box'
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/component/Loader/LoaderBox.vue